var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('data-table',{attrs:{"loader":_vm.loadData,"headers":_vm.headers,"title":"Assets","allow-add":true,"edit-handler":_vm.edit,"delete-handler":_vm.deleteItem},on:{"add-new":_vm.addNew,"done":function($event){return _vm.$router.back()}},scopedSlots:_vm._u([{key:"value",fn:function(ref){
var item = ref.item;
return [_c('p',{staticClass:"ma-0"},[_vm._v(_vm._s(_vm.formatCurrency(item.value)))])]}},{key:"rate",fn:function(ref){
var item = ref.item;
return [_c('p',{staticClass:"ma-0"},[_vm._v(_vm._s(item.rate)+" %")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }